/**
 * Belredenen-taxonomie — frontend-mirror.
 *
 * KEEP IN SYNC met api/_lib/belredenen.ts (codes + labels + commsLever).
 * De backend is de single source of truth; deze mirror bestaat zodat de UI
 * labels en comms-levers kan tonen zonder een extra fetch. Voeg je een code
 * toe of hernoem je 'm, doe het op beide plekken.
 */

export interface Belreden {
  code: string;
  label: string;
  commsLever: string;
}

export const BELREDENEN: readonly Belreden[] = [
  {
    code: 'status_doorlooptijd',
    label: 'Status / doorlooptijd',
    commsLever: 'Verwachte terugbrengdatum prominent in bevestigingsmail (S04) + dag-notificatie',
  },
  {
    code: 'afspraak_plannen',
    label: 'Afspraak plannen of verzetten',
    commsLever: 'Zelf ophaal-/bezorgmoment kiezen en verzetten in de client-app, duidelijk in de bevestigingsmail',
  },
  {
    code: 'offerte_prijs',
    label: 'Offerte of prijs',
    commsLever: 'Directe prijsindicatie in de offerte-flow + heldere offerte-bevestigingsmail (Q01)',
  },
  {
    code: 'betaling_factuur',
    label: 'Betaling of factuur',
    commsLever: 'Betaallink en factuur helder in de mail, betaalstatus zichtbaar in de client-app',
  },
  {
    code: 'klacht',
    label: 'Klacht',
    commsLever: 'Proactieve kwaliteitscheck na levering + duidelijke uitleg van de tevredenheidsgarantie',
  },
  {
    code: 'upsell_product',
    label: 'Product / upsell',
    commsLever: 'Ondertapijt en Vlekkenbaas duidelijk in de client-app + post-service-upsellmail',
  },
  {
    code: 'wijziging_order',
    label: 'Wijziging op de order',
    commsLever: 'Zelf order-details (adres, kleden) wijzigen in de client-app',
  },
  {
    code: 'overig',
    label: 'Overig',
    commsLever: 'Geen vast comms-moment; handmatig beoordelen',
  },
] as const;

export const BELREDENEN_CODES: ReadonlySet<string> = new Set(BELREDENEN.map((b) => b.code));

export function isValidCategory(x: unknown): x is string {
  return typeof x === 'string' && BELREDENEN_CODES.has(x);
}

export function labelFor(code: string | null | undefined): string {
  if (!code) return 'Onbekend';
  return BELREDENEN.find((b) => b.code === code)?.label ?? code;
}

export function commsLeverFor(code: string | null | undefined): string | null {
  if (!code) return null;
  return BELREDENEN.find((b) => b.code === code)?.commsLever ?? null;
}

/** Mens-override (note_category) wint van AI (call_category). Null als geen geldig. */
export function effectiveCategory(
  noteCategory: string | null | undefined,
  callCategory: string | null | undefined,
): string | null {
  if (isValidCategory(noteCategory)) return noteCategory;
  if (isValidCategory(callCategory)) return callCategory;
  return null;
}
